import React from "react";
import { View, StyleSheet, Modal, Pressable } from "react-native";

const ModalPopup = ({
  visible,
  children,
  setVisible = () => {},
  handleModal,
}) => {
  const onPressHandle = () => {
    if (handleModal) {
      handleModal();
    } else {
      setVisible(false);
    }
  };
  return (
    <Modal onRequestClose={onPressHandle} transparent visible={visible}>
      <Pressable onPress={onPressHandle} style={styles.modalBackGround}>
        <View style={[styles.modalContainer]}>{children}</View>
      </Pressable>
    </Modal>
  );
};

const styles = StyleSheet.create({
  modalBackGround: {
    flex: 1,
    backgroundColor: "rgba(0,0,0,0.5)",
    justifyContent: "center",
    alignItems: "center",
  },
  modalContainer: {
    width: "90%",
    backgroundColor: "white",
    padding: 20,
    justifyContent: "center",
    alignContent: "center",
    borderRadius: 10,
    elevation: 20,
  },
});

export default ModalPopup;
